import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessCapacityRoute: InvariantJiraRoute = {
	name: 'classic-business-capacity',
	exact: true,
	path: '/jira/core/projects/:projectKey/capacity/:itemId?',
};
